import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { Label } from '../Label'

export interface ILabelPrimaryTemplateProps extends ILabelProps {}

export const LabelLive = ({
  title = 'Live',
  withDot = true,
  ...rest
}: ILabelPrimaryTemplateProps): JSX.Element => (
  <Label title={title} {...rest} withDot={withDot} />
)
